import { graphql } from "@/lib/gql/__generated__";

export const Room_DesignPage_Query = graphql(`
	query Room_DesignPage($hotelID: ID!, $roomID: ID!) {
		room(hotelID: $hotelID, roomID: $roomID) {
			id
			hotelID
			roomID
			name
			mainKeyVisual {
				bucket
				key
				region
				mimeType
				fileName
			}
			tags
			tagsLocation
			article {
				bucket
				key
				region
				mimeType
				fileName
			}
			# articleTitle
		}
	}
`);
